// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import translate from "@insite/client-framework/Translate";
import { BillToModel, CarrierDto, ShipToModel, ShipViaDto } from "@insite/client-framework/Types/ApiModels";
import LocalizedDateTime from "@insite/content-library/Components/LocalizedDateTime";
// import BillingAddressInfoDisplay, {
//     BillingAddressInfoDisplayStyles,
// } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/BillingAddressInfoDisplay"; // Greif
// import ShippingAddressInfoDisplay, {
//     ShippingAddressInfoDisplayStyles,
// } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/ShippingAddressInfoDisplay"; // Greif
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import React from "react";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import { orderProps } from "@store/Themes/common/props/order";
import useMergeProps from "@toolkit/Framework/Common/Hooks/useMergeProps";
/* Starter Custom Code - End */

/* Greif Custom Code - Start */
import BillingAddressInfoDisplay, {
    BillingAddressInfoDisplayStyles,
} from "@store/Overrides/Widgets/CheckoutReviewAndSubmit/BillingAddressInfoDisplay";
import ShippingAddressInfoDisplay, {
    ShippingAddressInfoDisplayStyles,
} from "@store/Overrides/Widgets/CheckoutReviewAndSubmit/ShippingAddressInfoDisplay";
import { useSettingsCollection } from "@toolkit/Framework/Store/Context/ContextHooks";
/* Greif Custom Code - End */

interface OwnProps {
    billTo: BillToModel;
    shipTo: ShipToModel;
    carrier?: CarrierDto; // Greif
    shipVia?: ShipViaDto; // Greif
    deliveryDate: Date | null;
    onEditBillTo: () => void;
    onEditShipTo: () => void;
    extendedStyles?: BillingAndShippingAddressStyles;
    // Greif
    showBillingAddress?: boolean;
}

export interface BillingAndShippingAddressStyles {
    container?: GridContainerProps;
    carrierGridItem?: GridItemProps;
    carrierHeadingText?: TypographyPresentationProps;
    carrierText?: TypographyPresentationProps;
    shippingServiceGridItem?: GridItemProps;
    shippingServiceHeadingText?: TypographyPresentationProps;
    shippingServiceText?: TypographyPresentationProps;
    deliveryDateGridItem?: GridItemProps;
    deliveryDateHeadingText?: TypographyPresentationProps;
    deliveryDateText?: TypographyPresentationProps;
    shippingAddressGridItem?: GridItemProps;
    shippingAddress?: ShippingAddressInfoDisplayStyles;
    billingAddressGridItem?: GridItemProps;
    billingAddress?: BillingAddressInfoDisplayStyles;
}

export const billingAndShippingAddressStyles: BillingAndShippingAddressStyles = {
    container: orderProps.grid?.container,
    shippingAddressGridItem: orderProps.grid?.item,
    billingAddressGridItem: orderProps.grid?.item,
};

const BillingAndShippingInfo = ({
    billTo,
    shipTo,
    carrier,
    shipVia,
    deliveryDate,
    onEditBillTo,
    onEditShipTo,
    extendedStyles,
    // Greif
    showBillingAddress,
}: OwnProps) => {
    const styles = useMergeProps(billingAndShippingAddressStyles, extendedStyles); // Starter Custom Code

    /* Greif Custom Code - Start */
    const { customerSettings } = useSettingsCollection();
    /* Greif Custom Code - End */

    return (
        <GridContainer {...styles.container}>
            {/* Starter Removed - carrierGridItem */}
            {/* Starter Removed - shippingServiceGridItem */}
            {/* Starter Removed - deliveryDateGridItem */}
            {/* Starter Custom Code - Reversed billing and shiping order */}
            {showBillingAddress /* Greif */ && (
                <GridItem {...styles.billingAddressGridItem}>
                    <BillingAddressInfoDisplay
                        billTo={billTo}
                        onEdit={onEditBillTo}
                        extendedStyles={styles.billingAddress}
                        // Greif
                        isEditable={customerSettings.allowBillToAddressEdit}
                    />
                </GridItem>
            )}
            <GridItem {...styles.shippingAddressGridItem}>
                <ShippingAddressInfoDisplay
                    shipTo={shipTo}
                    onEdit={onEditShipTo}
                    extendedStyles={styles.shippingAddress}
                    // Greif
                    isEditable={customerSettings.allowShipToAddressEdit}
                />
            </GridItem>
        </GridContainer>
    );
};

export default BillingAndShippingInfo;
